import React from 'react';
import Header from '../../components/header';
import HeaderBackButton from '../../components/header-back-button';
import HeaderButton from '../../components/header-button';
import { CommentPublishButton } from '../publish-button';

const CommentEditPageHeader = props => (
  <Header
    left={<HeaderBackButton />}
    right={
      <CommentPublishButton>
        <HeaderButton text="comment-edit-page-header.update" />
      </CommentPublishButton>
    }
    {...props}
  />
);

export default CommentEditPageHeader;
